export default "<canvas id=\"scene\" #scene touch-action=\"none\"></canvas>\n"